import {
  StatusProps,
  IconsProps,
} from "@components/index";

import { isLate } from "@utils/datetime";

interface StatusResponse {
  text?: string,
  icon?: IconsProps["icon"],
  variant?: StatusProps["variant"],
};

const status_not_started: StatusResponse = {
  variant: "neutral",
  text: "Não iniciado",
};

const status_in_progress: StatusResponse = {
  variant: "info",
  text: "Em andamento",
};

const status_late: StatusResponse = {
  variant: "warning",
  icon: "warning",
  text: "Atrasado",
};

const status_finished: StatusResponse = {
  variant: "positive",
  icon: "check",
  text: "Finalizado",
};

const status_finished_late: StatusResponse = {
  variant: "warning",
  icon: "check",
  text: "Finalizado com atraso",
};

const status_completed_late_await_justification: StatusResponse = {
  variant: "awaiting-justification",
  text: "Aguardando justificativa",
};

const status_error: StatusResponse = {
  variant: "negative",
  icon: "spam",
  text: "Erro",
};

const status_awaiting_end: StatusResponse = {
  variant: "info",
  icon: "time",
  text: "Aguardando Fim",
};

const status_non_execution: StatusResponse = {
  variant: "warning",
  icon: "close",
  text: "Não Executado",
};

const statusMap: Record<Sentinel.Enumerators.ProcessExecutionStatus, StatusResponse> = {
  NOT_STARTED: undefined,
  STARTED_EARLY: status_in_progress,
  STARTED: status_in_progress,
  STARTED_LATE: status_late,
  DELAYED: status_late,
  AWAITING_END: status_awaiting_end,
  COMPLETED_EARLY: status_finished,
  COMPLETED: status_finished,
  COMPLETED_LATE: status_finished_late,
  COMPLETED_LATE_AWAIT_JUSTIFICATION: status_completed_late_await_justification,
  COMPLETED_LATE_AWAIT_FINALIZE_JUSTIFICATION: status_completed_late_await_justification,
  ERROR: status_error,
  CANCELED: undefined,
  NON_EXECUTION: status_non_execution,
};

export function useStatus(status?: Sentinel.Enumerators.ProcessExecutionStatus, plannedExecutionStart?: string): StatusResponse {
  let response = statusMap[status];

  if (status === "NOT_STARTED") {
    response = isLate(plannedExecutionStart) ? status_late : status_not_started;
  }

  return response;
}
